import React from "react";
import { ListContext } from "./List";
import { FlexDirection, Side, Size } from "../../types/system/Layout";
import Utilities from "../../foundation/Utility";
import ReactTooltip from "react-tooltip";

interface ListItemProps<T> {
    data?: T;

    autoHeight?: boolean;
    column?: boolean;
    selectable?: boolean;
    panel?: boolean;
    slim?: boolean;

    flex?: FlexDirection;

    clearanceSide?: Side;
    clearanceSize?: Size;

    bufferSide?: Side;
    bufferSize?: Size;

    tooltip?: string;
    tooltipSide?: string;

    contextkey?: string;
    contextvalue?: string;

    onClick?: (data: T) => void;
    onDoubleClick?: (data: T) => void;

    children?: React.ReactNode | React.ReactNode[];
}

interface ListItemState {
    data: any;
}

class ListItem<T> extends React.Component<ListItemProps<T>, ListItemState> {
    static contextType = ListContext;
    context!: React.ContextType<typeof ListContext>;

    state = {
        data: {},
    } as ListItemState;

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    onClick() {
        if (this.props.selectable)
            this.context.setSelectedItem(this.props.data ?? this.state.data);

        if (this.props.onClick)
            this.props.onClick(this.props.data ?? this.state.data);
    }
    onKeyPress(event: KeyboardEvent) {
        if (event.code === "Space" || event.code === "Enter") this.onClick();
    }
    onDoubleClick() {
        if (this.props.selectable)
            this.context.doubleClicked(this.props.data ?? this.state.data);

        if (this.props.onDoubleClick)
            this.props.onDoubleClick(this.props.data ?? this.state.data);
    }

    render(): React.ReactNode {
        let classes = "item";

        if (this.props.autoHeight) classes += " auto";
        if (this.props.column) classes += " item-column";
        if (this.props.selectable) classes += " selectable";
        if (this.context.isSelected(this.props.data ?? this.state.data))
            classes += " selected";
        if (this.props.slim) classes += " slim";
        if (this.props.onClick) classes += " clickable";
        if (this.props.panel) classes += " panel";

        switch (this.props.flex) {
            case "row":
                classes += " flex-row";
                break;
            case "column":
                classes += " flex-column";
                break;
        }

        // Clearance classes
        if (!!this.props.clearanceSide) {
            classes += ` ${Utilities.getSideClass(
                this.props.clearanceSide,
            )}clearance${Utilities.getSizeClass(this.props.clearanceSize)}`;
        }

        // Buffer classes
        if (!!this.props.bufferSide) {
            classes += ` ${Utilities.getSideClass(
                this.props.bufferSide,
            )}buffer${Utilities.getSizeClass(this.props.bufferSize)}`;
        }

        return (
            <div
                className={classes}
                tabIndex={this.props.selectable ? 0 : null}
                onClick={this.onClick.bind(this)}
                onKeyUp={this.onKeyPress.bind(this)}
                onDoubleClick={this.onDoubleClick.bind(this)}
                data-tip={this.props.tooltip}
                data-place={this.props.tooltipSide}
                data-contextkey={this.props.contextkey}
                data-contextvalue={this.props.contextvalue}>
                {this.props.children}
            </div>
        );
    }
}

export default ListItem;
